module.exports = __webpack_public_path__ + "bdefdfeed6964f8440f8924a7917a640.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img-layout/bg1.jpg
 ** module id = 507
 ** module chunks = 1
 **/